const APP_MOUNT = 'app_mount';
const APP_RESET = 'app_reset';
const APP_FETCH_DASHBOARD = 'app_fetch_dashboard';
const APP_FETCH_AGENCY = 'app_fetch_agency';
const APP_UPDATE_AGENCY = 'app_persist_agency';
const CREATE_FILES_AGENCY = 'app_create_agency_files';
const FETCH_FILES_AGENCY = 'app_fetch_agency_files';
export default {
    APP_MOUNT,
    APP_UPDATE_AGENCY,
    APP_FETCH_AGENCY,
    APP_RESET,
    APP_FETCH_DASHBOARD,
    CREATE_FILES_AGENCY,
    FETCH_FILES_AGENCY,
};
